import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getContact, editContact } from "../../store/actions/contacts_action";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import AddForm from "../../components/common/AddForm";
import { upload } from "../../shared/upload";
import { initialValues, inputFields } from "../../shared/enums/contacts_enum";
const EditContact = ({
  editContact,
  getContact,
  match,
  contact: { loading, contact },
}) => {
  let history = useHistory();
  useEffect(() => {
    getContact(match.params.id);
  }, [match]);
  const [featuredImage, setFeaturedImage] = useState(null);
  const [gallery, setGallery] = useState(null);
  const submitContact = async (values) => {
    if (featuredImage || gallery) {
      const images = await upload(featuredImage, gallery);
      if (images) {
        if (images.featured_image) {
          values.featured_image = images.featured_image;
        }
        if (images.gallery_images) {
          values.gallery = images.gallery_images;
        }
      }
    }
    await editContact(contact.id, values);
    history.push(`/contacts/${contact.id}/view`);
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Edit Contact"
          mainLinkTitle="Contacts"
          mainLinkUrl="/contacts"
          activeLink="Edit"
        />
      </div>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card">
            {!loading ? (
              contact && (
                <div>
                  <div className="card-header">
                    <div>
                      <h4 className="card-title">
                        {contact[Object.keys(inputFields)[0]]} -
                        <span>Edit</span>
                      </h4>
                      <p className="card-title-desc">
                        <Link to="/contacts" className="btn btn-soft-light">
                          <i className="fa fa-angle-left"></i> Contacts
                        </Link>
                        <Link
                          to={`/contacts/${contact.id}/view`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-eye"></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <AddForm
                    data={contact}
                    edit={true}
                    featuredImage={featuredImage}
                    gallery={gallery}
                    setFeaturedImage={setFeaturedImage}
                    setGallery={setGallery}
                    submitForm={submitContact}
                    inputFields={inputFields}
                    initialValues={initialValues}
                  />
                </div>
              )
            ) : (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  alert: state.alert,
  contact: state.contact,
});

const mapDispatchToProps = { editContact, getContact };

export default connect(mapStateToProps, mapDispatchToProps)(EditContact);
